(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["vstories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('story-video-list')) {
    customElements.define('story-video-list', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-story-open]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            const dialog = this.querySelector(`#${CSS.escape(trigger.dataset.storyOpen)}`);
            if (!dialog) return;
            dialog.showModal();
            const video = dialog.querySelector('video');
            if (video) video.play();
          });
        });

        this.querySelectorAll('.story-videos__dialog').forEach((dialog) => {
          const closeDialog = () => {
            const video = dialog.querySelector('video');
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
            dialog.close();
          };

          dialog.querySelector('[data-story-close]')?.addEventListener('click', closeDialog);
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) closeDialog();
          });
          dialog.addEventListener('cancel', (event) => {
            event.preventDefault();
            closeDialog();
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["wall-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wall-gallery')) {
    class WallGallery extends HTMLElement {
      connectedCallback() {
        this.style.setProperty('--wall-cols', this.dataset.columns || 4);
        this.endpoint = this.dataset.endpoint || '';
        this.maxBytes = (parseFloat(this.dataset.maxMb) || 15) * 1024 * 1024;
        this.form = this.querySelector('[data-form]');
        this.email = '';
        this.file = null;

        this.querySelectorAll('[data-filter]').forEach((b) => b.addEventListener('click', () => this.filter(b)));
        this.autoplayVideos();

        if (!this.form) return;
        this.querySelector('[data-open]')?.addEventListener('click', () => this.open());
        this.form.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.form.addEventListener('click', (e) => { if (e.target === this.form) this.close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.form.hidden) this.close(); });

        this.form.querySelector('[data-next]').addEventListener('click', () => this.stepEmail());
        this.form.querySelector('[data-back]').addEventListener('click', () => this.show(1));
        this.form.querySelector('[data-send]').addEventListener('click', () => this.send());
        this.form.querySelector('[data-file]').addEventListener('change', (e) => this.pick(e.target.files[0]));
        this.form.querySelector('input[type=email]').addEventListener('keydown', (e) => { if (e.key === 'Enter') this.stepEmail(); });

        const drop = this.form.querySelector('[data-drop]');
        ['dragenter', 'dragover'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.add('is-over'); }));
        ['dragleave', 'drop'].forEach((ev) => drop.addEventListener(ev, (e) => { e.preventDefault(); drop.classList.remove('is-over'); }));
        drop.addEventListener('drop', (e) => this.pick(e.dataTransfer.files[0]));
      }

      autoplayVideos() {
        const videos = this.querySelectorAll('video.wall__media');
        if (!videos.length) return;

        videos.forEach((v) => {
          v.muted = true;
          v.loop = true;
          v.playsInline = true;
          v.setAttribute('muted', '');
          v.setAttribute('playsinline', '');
          v.removeAttribute('controls');
        });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          videos.forEach((v) => v.setAttribute('controls', ''));
          return;
        }

        if (!('IntersectionObserver' in window)) {
          videos.forEach((v) => v.play().catch(() => {}));
          return;
        }

        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const v = e.target;
            if (e.isIntersecting) {
              v.play().catch(() => {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { threshold: 0.4 });

        videos.forEach((v) => io.observe(v));
      }

      filter(btn) {
        const v = btn.dataset.filter;
        this.querySelectorAll('[data-filter]').forEach((b) => b.classList.toggle('is-on', b === btn));
        this.querySelectorAll('.wall__tile').forEach((t) => {
          t.classList.toggle('is-hidden', v !== '' && (t.dataset.modele || '') !== v);
        });
      }

      open() {
        this.form.hidden = false;
        document.body.style.overflow = 'hidden';
        this.show(1);
        this.form.querySelector('input[type=email]').focus();
      }

      close() {
        this.form.hidden = true;
        document.body.style.overflow = '';
      }

      show(n) {
        this.form.querySelectorAll('[data-step]').forEach((s) => { s.hidden = s.dataset.step !== String(n); });
        this.form.querySelectorAll('[data-error]').forEach((e) => { e.hidden = true; e.textContent = ''; });
      }

      error(step, msg) {
        const el = this.form.querySelector(`[data-step="${step}"] [data-error]`);
        el.textContent = msg;
        el.hidden = false;
      }

      stepEmail() {
        const input = this.form.querySelector('input[type=email]');
        const val = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val)) {
          this.error(1, 'Entre une adresse email valide.');
          input.focus();
          return;
        }
        this.email = val;
        this.form.querySelector('[data-email-echo]').textContent = `Envoi lié à ${val}`;
        if (this.dataset.subscribe === 'true') this.subscribe(val);
        this.show(2);
      }

      subscribe(email) {
        const body = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'ugc,newsletter' });
        fetch('/contact', { method: 'POST', body, headers: { 'Accept': 'text/html' } }).catch(() => {});
      }

      pick(file) {
        if (!file) return;
        if (file.size > this.maxBytes) {
          this.error(2, `Fichier trop lourd (${(file.size / 1048576).toFixed(1)} Mo). Maximum ${this.dataset.maxMb} Mo.`);
          return;
        }
        if (!/^(image\/(jpeg|png|webp|heic)|video\/(mp4|quicktime|webm))$/.test(file.type)) {
          this.error(2, 'Format non pris en charge.');
          return;
        }
        this.file = file;
        this.form.querySelector('[data-drop-label]').textContent = file.name;
        const prev = this.form.querySelector('[data-preview]');
        prev.innerHTML = '';
        const url = URL.createObjectURL(file);
        if (file.type.startsWith('video/')) {
          const v = document.createElement('video');
          v.src = url; v.muted = true; v.playsInline = true; v.controls = true;
          prev.appendChild(v);
        } else {
          const img = document.createElement('img');
          img.src = url; img.alt = '';
          prev.appendChild(img);
        }
        prev.hidden = false;
        this.show(2);
      }

      async send() {
        if (!this.file) { this.error(2, 'Ajoute une photo ou une vidéo.'); return; }
        const consent = this.form.querySelector('[data-consent]');
        if (consent && !consent.checked) { this.error(2, 'Coche la case pour nous autoriser à publier ta photo.'); return; }
        if (!this.endpoint) { this.error(2, 'Envoi indisponible pour le moment.'); return; }

        const btn = this.form.querySelector('[data-send]');
        btn.disabled = true;
        const fd = new FormData();
        fd.append('email', this.email);
        fd.append('pseudo', this.form.querySelector('input[name=pseudo]').value.trim());
        fd.append('media', this.file, this.file.name);
        fd.append('product_id', this.dataset.productId);
        fd.append('product_handle', this.dataset.productHandle);
        fd.append('page_url', location.href);
        fd.append('consent', consent ? 'true' : 'n/a');

        try {
          const res = await fetch(this.endpoint, { method: 'POST', body: fd });
          if (!res.ok) throw new Error(res.status);
          this.show(3);
          this.file = null;
        } catch (e) {
          this.error(2, "L'envoi a échoué. Réessaie dans un instant.");
        } finally {
          btn.disabled = false;
        }
      }
    }
    customElements.define('wall-gallery', WallGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
